/* NewsletterSignupV2FailedTemplate */
import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { NewsletterSignupV2Component } from '../newsletter-signup-v2';

/**
 * Definition of  parameters that the template needs to work.
 */
interface NewsletterSignupV2FailedTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: NewsletterSignupV2Component;
  // Specify parameters that are required to be passed down to the template here.
}

const NewsletterSignupV2FailedTemplate: FunctionalComponent<NewsletterSignupV2FailedTemplateProps> = ({
  controller,
}) => (
  <cwc-newsletter-signup-main>
    <slot name="failed-illustration" />
    {controller.failedHeadline ? (
      <cwc-newsletter-signup-headline>
        <slot name="failed-headline" />
      </cwc-newsletter-signup-headline>
    ) : (
      ''
    )}
    {controller.failedSubheadline ? (
      <cwc-newsletter-signup-subheadline>
        <slot name="failed-subheadline" />
      </cwc-newsletter-signup-subheadline>
    ) : (
      ''
    )}
    {controller.failedText ? (
      <cwc-newsletter-signup-text>
        <slot name="failed-text" />
      </cwc-newsletter-signup-text>
    ) : (
      ''
    )}
    <div class="btn-container">
      <button
        class="csc-button csc-button-basic csc-button-strong--on-light"
        type="button"
        onClick={() => controller.signUpRetry()}
      >
        {controller.buttonRetryText}
      </button>
      <a
        class="csc-button csc-button-basic csc-button-lite--on-light"
        href={controller.buttonContactUrl}
        target={controller.buttonContactTarget}
      >
        {controller.buttonContactText}
      </a>
    </div>
  </cwc-newsletter-signup-main>
);

export default NewsletterSignupV2FailedTemplate;
